// src/utils/countryCurrency.js
// GENERATED from the backend file currency21/country_currency.py - keep both in sync.
// country name -> [currency code, symbol, currency name]
export const COUNTRY_CURRENCY = {
  "Afghanistan": ["AFN", "؋", "Afghan Afghani"],
  "Albania": ["ALL", "L", "Albanian Lek"],
  "Algeria": ["DZD", "د.ج", "Algerian Dinar"],
  "Andorra": ["EUR", "€", "Euro"],
  "Angola": ["AOA", "Kz", "Angolan Kwanza"],
  "Antigua and Barbuda": ["XCD", "$", "East Caribbean Dollar"],
  "Argentina": ["ARS", "$", "Argentine Peso"],
  "Armenia": ["AMD", "֏", "Armenian Dram"],
  "Australia": ["AUD", "$", "Australian Dollar"],
  "Austria": ["EUR", "€", "Euro"],
  "Azerbaijan": ["AZN", "₼", "Azerbaijani Manat"],
  "Bahamas": ["BSD", "$", "Bahamian Dollar"],
  "Bahrain": ["BHD", ".د.ب", "Bahraini Dinar"],
  "Bangladesh": ["BDT", "৳", "Bangladeshi Taka"],
  "Barbados": ["BBD", "$", "Barbadian Dollar"],
  "Belarus": ["BYN", "Br", "Belarusian Ruble"],
  "Belgium": ["EUR", "€", "Euro"],
  "Belize": ["BZD", "$", "Belize Dollar"],
  "Benin": ["XOF", "CFA", "West African CFA Franc"],
  "Bhutan": ["BTN", "Nu.", "Bhutanese Ngultrum"],
  "Bolivia": ["BOB", "Bs.", "Bolivian Boliviano"],
  "Bosnia and Herzegovina": ["BAM", "KM", "Bosnia-Herzegovina Convertible Mark"],
  "Botswana": ["BWP", "P", "Botswanan Pula"],
  "Brazil": ["BRL", "R$", "Brazilian Real"],
  "Brunei": ["BND", "$", "Brunei Dollar"],
  "Bulgaria": ["BGN", "лв", "Bulgarian Lev"],
  "Burkina Faso": ["XOF", "CFA", "West African CFA Franc"],
  "Burundi": ["BIF", "FBu", "Burundian Franc"],
  "Cabo Verde": ["CVE", "$", "Cape Verdean Escudo"],
  "Cambodia": ["KHR", "៛", "Cambodian Riel"],
  "Cameroon": ["XAF", "FCFA", "Central African CFA Franc"],
  "Canada": ["CAD", "$", "Canadian Dollar"],
  "Central African Republic": ["XAF", "FCFA", "Central African CFA Franc"],
  "Chad": ["XAF", "FCFA", "Central African CFA Franc"],
  "Chile": ["CLP", "$", "Chilean Peso"],
  "China": ["CNY", "¥", "Chinese Yuan"],
  "Colombia": ["COP", "$", "Colombian Peso"],
  "Comoros": ["KMF", "CF", "Comorian Franc"],
  "Congo": ["XAF", "FCFA", "Central African CFA Franc"],
  "Costa Rica": ["CRC", "₡", "Costa Rican Colon"],
  "Croatia": ["EUR", "€", "Euro"],
  "Cuba": ["CUP", "$", "Cuban Peso"],
  "Cyprus": ["EUR", "€", "Euro"],
  "Czech Republic": ["CZK", "Kč", "Czech Koruna"],
  "Denmark": ["DKK", "kr", "Danish Krone"],
  "Djibouti": ["DJF", "Fdj", "Djiboutian Franc"],
  "Dominica": ["XCD", "$", "East Caribbean Dollar"],
  "Dominican Republic": ["DOP", "RD$", "Dominican Peso"],
  "Ecuador": ["USD", "$", "US Dollar"],
  "Egypt": ["EGP", "£", "Egyptian Pound"],
  "El Salvador": ["USD", "$", "US Dollar"],
  "Equatorial Guinea": ["XAF", "FCFA", "Central African CFA Franc"],
  "Eritrea": ["ERN", "Nfk", "Eritrean Nakfa"],
  "Estonia": ["EUR", "€", "Euro"],
  "Eswatini": ["SZL", "L", "Swazi Lilangeni"],
  "Ethiopia": ["ETB", "Br", "Ethiopian Birr"],
  "Fiji": ["FJD", "$", "Fijian Dollar"],
  "Finland": ["EUR", "€", "Euro"],
  "France": ["EUR", "€", "Euro"],
  "Gabon": ["XAF", "FCFA", "Central African CFA Franc"],
  "Gambia": ["GMD", "D", "Gambian Dalasi"],
  "Georgia": ["GEL", "₾", "Georgian Lari"],
  "Germany": ["EUR", "€", "Euro"],
  "Ghana": ["GHS", "₵", "Ghanaian Cedi"],
  "Greece": ["EUR", "€", "Euro"],
  "Grenada": ["XCD", "$", "East Caribbean Dollar"],
  "Guatemala": ["GTQ", "Q", "Guatemalan Quetzal"],
  "Guinea": ["GNF", "FG", "Guinean Franc"],
  "Guinea-Bissau": ["XOF", "CFA", "West African CFA Franc"],
  "Guyana": ["GYD", "$", "Guyanaese Dollar"],
  "Haiti": ["HTG", "G", "Haitian Gourde"],
  "Honduras": ["HNL", "L", "Honduran Lempira"],
  "Hungary": ["HUF", "Ft", "Hungarian Forint"],
  "Iceland": ["ISK", "kr", "Icelandic Krona"],
  "India": ["INR", "₹", "Indian Rupee"],
  "Indonesia": ["IDR", "Rp", "Indonesian Rupiah"],
  "Iran": ["IRR", "﷼", "Iranian Rial"],
  "Iraq": ["IQD", "ع.د", "Iraqi Dinar"],
  "Ireland": ["EUR", "€", "Euro"],
  "Israel": ["ILS", "₪", "Israeli New Shekel"],
  "Italy": ["EUR", "€", "Euro"],
  "Jamaica": ["JMD", "$", "Jamaican Dollar"],
  "Japan": ["JPY", "¥", "Japanese Yen"],
  "Jordan": ["JOD", "د.ا", "Jordanian Dinar"],
  "Kazakhstan": ["KZT", "₸", "Kazakhstani Tenge"],
  "Kenya": ["KES", "KSh", "Kenyan Shilling"],
  "Kiribati": ["AUD", "$", "Australian Dollar"],
  "Kuwait": ["KWD", "د.ك", "Kuwaiti Dinar"],
  "Kyrgyzstan": ["KGS", "с", "Kyrgystani Som"],
  "Laos": ["LAK", "₭", "Laotian Kip"],
  "Latvia": ["EUR", "€", "Euro"],
  "Lebanon": ["LBP", "ل.ل", "Lebanese Pound"],
  "Lesotho": ["LSL", "L", "Lesotho Loti"],
  "Liberia": ["LRD", "$", "Liberian Dollar"],
  "Libya": ["LYD", "ل.د", "Libyan Dinar"],
  "Liechtenstein": ["CHF", "CHF", "Swiss Franc"],
  "Lithuania": ["EUR", "€", "Euro"],
  "Luxembourg": ["EUR", "€", "Euro"],
  "Madagascar": ["MGA", "Ar", "Malagasy Ariary"],
  "Malawi": ["MWK", "MK", "Malawian Kwacha"],
  "Malaysia": ["MYR", "RM", "Malaysian Ringgit"],
  "Maldives": ["MVR", "Rf", "Maldivian Rufiyaa"],
  "Mali": ["XOF", "CFA", "West African CFA Franc"],
  "Malta": ["EUR", "€", "Euro"],
  "Marshall Islands": ["USD", "$", "US Dollar"],
  "Mauritania": ["MRU", "UM", "Mauritanian Ouguiya"],
  "Mauritius": ["MUR", "₨", "Mauritian Rupee"],
  "Mexico": ["MXN", "$", "Mexican Peso"],
  "Micronesia": ["USD", "$", "US Dollar"],
  "Moldova": ["MDL", "L", "Moldovan Leu"],
  "Monaco": ["EUR", "€", "Euro"],
  "Mongolia": ["MNT", "₮", "Mongolian Tugrik"],
  "Montenegro": ["EUR", "€", "Euro"],
  "Morocco": ["MAD", "د.م.", "Moroccan Dirham"],
  "Mozambique": ["MZN", "MT", "Mozambican Metical"],
  "Myanmar": ["MMK", "K", "Myanmar Kyat"],
  "Namibia": ["NAD", "$", "Namibian Dollar"],
  "Nauru": ["AUD", "$", "Australian Dollar"],
  "Nepal": ["NPR", "₨", "Nepalese Rupee"],
  "Netherlands": ["EUR", "€", "Euro"],
  "New Zealand": ["NZD", "$", "New Zealand Dollar"],
  "Nicaragua": ["NIO", "C$", "Nicaraguan Cordoba"],
  "Niger": ["XOF", "CFA", "West African CFA Franc"],
  "Nigeria": ["NGN", "₦", "Nigerian Naira"],
  "Norway": ["NOK", "kr", "Norwegian Krone"],
  "Oman": ["OMR", "ر.ع.", "Omani Rial"],
  "Pakistan": ["PKR", "Rs.", "Pakistani Rupee"],
  "Palau": ["USD", "$", "US Dollar"],
  "Palestine": ["ILS", "₪", "Israeli New Shekel"],
  "Panama": ["PAB", "B/.", "Panamanian Balboa"],
  "Papua New Guinea": ["PGK", "K", "Papua New Guinean Kina"],
  "Paraguay": ["PYG", "₲", "Paraguayan Guarani"],
  "Peru": ["PEN", "S/.", "Peruvian Sol"],
  "Philippines": ["PHP", "₱", "Philippine Peso"],
  "Poland": ["PLN", "zł", "Polish Zloty"],
  "Portugal": ["EUR", "€", "Euro"],
  "Qatar": ["QAR", "ر.ق", "Qatari Rial"],
  "Romania": ["RON", "lei", "Romanian Leu"],
  "Russia": ["RUB", "₽", "Russian Ruble"],
  "Rwanda": ["RWF", "FRw", "Rwandan Franc"],
  "Saint Kitts and Nevis": ["XCD", "$", "East Caribbean Dollar"],
  "Saint Lucia": ["XCD", "$", "East Caribbean Dollar"],
  "Saint Vincent and the Grenadines": ["XCD", "$", "East Caribbean Dollar"],
  "Samoa": ["WST", "T", "Samoan Tala"],
  "San Marino": ["EUR", "€", "Euro"],
  "Sao Tome and Principe": ["STN", "Db", "Sao Tomean Dobra"],
  "Saudi Arabia": ["SAR", "ر.س", "Saudi Riyal"],
  "Senegal": ["XOF", "CFA", "West African CFA Franc"],
  "Serbia": ["RSD", "дин.", "Serbian Dinar"],
  "Seychelles": ["SCR", "₨", "Seychellois Rupee"],
  "Sierra Leone": ["SLE", "Le", "Sierra Leonean Leone"],
  "Singapore": ["SGD", "$", "Singapore Dollar"],
  "Slovakia": ["EUR", "€", "Euro"],
  "Slovenia": ["EUR", "€", "Euro"],
  "Solomon Islands": ["SBD", "$", "Solomon Islands Dollar"],
  "Somalia": ["SOS", "S", "Somali Shilling"],
  "South Africa": ["ZAR", "R", "South African Rand"],
  "South Sudan": ["SSP", "£", "South Sudanese Pound"],
  "Spain": ["EUR", "€", "Euro"],
  "Sri Lanka": ["LKR", "Rs.", "Sri Lankan Rupee"],
  "Sudan": ["SDG", "ج.س.", "Sudanese Pound"],
  "Suriname": ["SRD", "$", "Surinamese Dollar"],
  "Sweden": ["SEK", "kr", "Swedish Krona"],
  "Switzerland": ["CHF", "CHF", "Swiss Franc"],
  "Syria": ["SYP", "£S", "Syrian Pound"],
  "Taiwan": ["TWD", "NT$", "New Taiwan Dollar"],
  "Tajikistan": ["TJS", "SM", "Tajikistani Somoni"],
  "Tanzania": ["TZS", "TSh", "Tanzanian Shilling"],
  "Thailand": ["THB", "฿", "Thai Baht"],
  "Timor-Leste": ["USD", "$", "US Dollar"],
  "Togo": ["XOF", "CFA", "West African CFA Franc"],
  "Tonga": ["TOP", "T$", "Tongan Paanga"],
  "Trinidad and Tobago": ["TTD", "$", "Trinidad and Tobago Dollar"],
  "Tunisia": ["TND", "د.ت", "Tunisian Dinar"],
  "Turkey": ["TRY", "₺", "Turkish Lira"],
  "Turkmenistan": ["TMT", "m", "Turkmenistani Manat"],
  "Tuvalu": ["AUD", "$", "Australian Dollar"],
  "Uganda": ["UGX", "USh", "Ugandan Shilling"],
  "Ukraine": ["UAH", "₴", "Ukrainian Hryvnia"],
  "United Arab Emirates": ["AED", "د.إ", "UAE Dirham"],
  "United Kingdom": ["GBP", "£", "British Pound"],
  "United States": ["USD", "$", "US Dollar"],
  "Uruguay": ["UYU", "$", "Uruguayan Peso"],
  "Uzbekistan": ["UZS", "so'm", "Uzbekistani Som"],
  "Vanuatu": ["VUV", "VT", "Vanuatu Vatu"],
  "Vatican City": ["EUR", "€", "Euro"],
  "Venezuela": ["VES", "Bs.", "Venezuelan Bolivar"],
  "Vietnam": ["VND", "₫", "Vietnamese Dong"],
  "Yemen": ["YER", "﷼", "Yemeni Rial"],
  "Zambia": ["ZMW", "ZK", "Zambian Kwacha"],
  "Zimbabwe": ["ZWL", "$", "Zimbabwean Dollar"],
};